import { del, get, post, put } from './request'

interface Award {
    supplier: string;
    propertyId: string;
    property: {
        affiliations: {
            awards: Array<object>
        }
    };
}

interface Loyalty {
    supplier: string;
    propertyId: string;
    property: {
        affiliations: {
            loyaltyprograms: Array<object>
        }
    };
}

export const getAffiliations = (supplier: string, propertyid: string) => get(`/property/affiliations?supplier=${supplier}&propertyid=${propertyid}`)
export const addAward = (award: Award) => post('/property/affiliations/award', award)
export const updateAward = (award: Award) => put('/property/affiliations/award', award)
export const deleteAward = (award: Award) => del('/property/affiliations/award', award)

export const addLoyalty = (loyalty: Loyalty) => post('/property/affiliations/loyalty', loyalty)
export const updateLoyalty = (loyalty: Loyalty) => put('/property/affiliations/loyalty', loyalty)
export const deleteLoyalty = (loyalty: Loyalty) => del('/property/affiliations/loyalty', loyalty)